export default "__VITE_ASSET__gLdlyPf3__"